<template>
  <section>
    <h1 class="sponsor__title">Sponsorship Levels:</h1>
    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div
        v-for="[amount, description] of amounts.slice(0, 4)"
        :key="amount"
        class="amount-row"
      >
        <input
          :id="`amount${amount}`"
          type="radio"
          class="amount"
          @click="selectedAmount = amount"
          :checked="selectedAmount == amount"
        />
        <FormLabel :for="`amount${amount}`">
          <MoneyFormat
            class="label-amount"
            :value="amount"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
          <span class="label-description">{{ description }}</span>
        </FormLabel>
      </div>
    </div>

    <h2>Ticket Prices:</h2>
    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div class="amount-row">
        <input
          id="amount__single"
          type="checkbox"
          class="amount"
          :checked="singleReservation"
          @click="setValue('custom.singleReservation', !singleReservation)"
        />
        <FormLabel for="amount__single">
          <span class="discount-label" v-if="getValue('custom.coupon') === 'BJYJP'">$250</span>
          <MoneyFormat
            class="label-amount"
            :value="getValue('custom.coupon') === 'BJYJP' ? 150 : 250"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
          <span class="label-description">Single Reservation</span>
        </FormLabel>
      </div>

      <div class="amount-row">
        <input
          id="amount__couple"
          type="checkbox"
          class="amount"
          :checked="coupleReservation"
          @click="setValue('custom.coupleReservation', !coupleReservation)"
        />
        <FormLabel for="amount__couple">
          <span class="discount-label" v-if="getValue('custom.coupon') === 'BJYJP'">$400</span>
          <MoneyFormat
            class="label-amount"
            :value="getValue('custom.coupon') === 'BJYJP' ? 300 : 400"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
          <span class="label-description">Couple Reservation</span>
        </FormLabel>
      </div>

      <div class="amount-row" v-if="form.amount && Number(form.amount) > 0">
        <input
          id="amount__yachadspecial"
          type="checkbox"
          class="amount"
          :checked="yachadMember"
          @click="setValue('custom.yachadMember', !yachadMember)"
        />
        <FormLabel for="amount__yachadspecial">
          <MoneyFormat
            class="label-amount"
            :value="100"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
          <span class="label-description">Yachad Member Reservation*</span>
        </FormLabel>
      </div>
    </div>
    <p class="note">
      * Yachad members must be accompanied by at least 1 paying adult. Limit 10.
    </p>

    <ErrorLabel field="amount" />

    <div
      class="clear__btn"
      v-if="form.amount && Number(form.amount) > 0"
      @click="clearOutSelectedValue"
    >
      Clear Selection
    </div>

    <ul class="payment__totals" v-if="form.amount && Number(form.amount) > 0">
      <li class="payment__summary">Summary</li>
      <li v-if="selectedAmount">
        <div class="payment__tot__desc">Sponsorship:</div>
        <div class="payment__tot__amt">
          <span>${{ selectedAmount }}</span>
        </div>
      </li>
      <li v-if="singleReservation || coupleReservation || yachadMember">
        <div class="payment__tot__desc">Tickets:</div>
        <div class="payment__tot__amt">
          <span v-if="singleReservation">Single Ticket</span>
          <span v-if="coupleReservation">Couple Ticket</span>
          <span v-if="yachadMember">Yachad Member</span>
        </div>
      </li>
      <li v-if="form.amount && Number(form.amount)">
        <div class="payment__tot__desc">Total Amount:</div>
        <div class="payment__tot__amt">
          <span class="pay__total">${{ form.amount }}</span>
        </div>
      </li>
    </ul>    
    <FormRow>
      <div style="width: 100%" class="coupon__field">
        <FormLabel class="control-label"> Coupon Code: </FormLabel>
        <FormInput type="text" class="width-half" field="custom.coupon"/>
      </div>
    </FormRow>
  </section>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const ticketsQnt = ref();
    const selectedAmount = ref(0);
    const customAmount = ref(0);
    const discountAmount = ref(0);
    const customSelected = ref(false);
    const singleReservation = computed(() => getValue("custom.singleReservation"));
    const coupleReservation = computed(() => getValue("custom.coupleReservation"));
    const yachadMember = computed(() => getValue("custom.yachadMember"));

    function clearOutSelectedValue() {
      if (selectedAmount) {
        selectedAmount.value = 0;
        customSelected.value = false;
        customAmount.value = 0;
        setValue("custom.singleReservation", null);
        setValue("custom.coupleReservation", null);
        setValue("custom.yachadMember", null);
        setValue("amount", null);
      }
    }

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;
        customAmount.value = 0;
        setValue("custom.singleReservation", null);
        setValue("custom.coupleReservation", null);
        setValue("custom.yachadMember", null);
        setValue("amount", "" + selectedAmount);
      }
    });

    watch(
      () => getValue("custom.coupon"),
      () => {
        if(getValue("custom.coupon")=='BJYJP') {
          discountAmount.value = 100
          if(getValue("custom.singleReservation")) {
            customAmount.value = customAmount.value! - 100
          }
          if(getValue("custom.coupleReservation")) {
            customAmount.value = customAmount.value! - 100
          }
        } else {
          discountAmount.value = 0
          if(getValue("custom.singleReservation")) {
            customAmount.value = customAmount.value! + 100
          }
          if(getValue("custom.coupleReservation")) {
            customAmount.value = customAmount.value! + 100
          }
        }
        setValue("amount", "" + (selectedAmount.value + customAmount.value));
      }
    );
    watch(
      () => getValue("custom.singleReservation"),
      () => {
        if (getValue("custom.singleReservation")) {
          customAmount.value = customAmount.value! + 250 - discountAmount.value!;
          customSelected.value = true;
        } else {
          if (customSelected.value) {
            customAmount.value = customAmount.value! - 250 + discountAmount.value!;
          }
        }
        setValue("amount", "" + (selectedAmount.value + customAmount.value));
      }
    );
    watch(
      () => getValue("custom.coupleReservation"),
      () => {
        if (getValue("custom.coupleReservation")) {
          customAmount.value = customAmount.value! + 400 - discountAmount.value!;
          customSelected.value = true;
        } else {
          if (customSelected.value) customAmount.value = customAmount.value! - 400 + discountAmount.value!;
        }
        setValue("amount", "" + (selectedAmount.value + customAmount.value));
      }
    );
    watch(
      () => getValue("custom.yachadMember"),
      () => {
        if (getValue("custom.yachadMember")) {
          customAmount.value = customAmount.value! + 100;
          customSelected.value = true;
        } else {
          if (customSelected.value) customAmount.value = customAmount.value! - 100;
        }
        setValue("amount", "" + (selectedAmount.value + customAmount.value));
      }
    );

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
        //@ts-ignore
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      ticketsQnt,
      getValue,
      clearOutSelectedValue,
      setValue,
      customSelected,
      singleReservation,
      coupleReservation,
      yachadMember,
      discountAmount
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      font-weight: 500 !important;
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
input#tickets_qnt {
  background: #fff !important;
  box-shadow: none;
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: 500;
  display: inline-block;
  padding: 10px 5px 0px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
  @media (min-width: 720px) {
    padding: 5px 5px 0px;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
  padding: 0px 5px 10px;
  align-items: center;
  justify-content: center;
  height: auto;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
.yachad-styled.styled-radio-container--ou-donation.styled-radio-container label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}
.amount_other__wrapper.amount-row {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }
}
.amount-row.tickets-num {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin-top: 10px;
  }
}
::v-deep h1.sponsor__title {
  margin-bottom: 20px;
  margin-top: 40px;
  font-weight: 200;
  font-size: 30px;
  text-transform: uppercase;
  text-align: center;
  color: black;
}
ul.payment__totals {
  padding: 15px 0px 0px;
  margin: 20px auto 0px;
  max-width: 320px;
  width: 100%;
  border-top: 1px solid #eff2f6;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
    padding: 0px 0px 4px;
    margin-bottom: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #4b5866;

    &.payment__summary {
      text-align: center;
      flex: 1;
      width: 100%;
      justify-content: center;
    }
  }

  .payment__tot__desc {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    text-transform: capitalize;
    color: #232e38;
  }
  .payment__tot__amt {
    width: 50%;
    font-size: 14px;
    font-style: italic;
    line-height: 18px;
    text-align: right;
    color: black;
    span {
      display: block;
      &.pay__total {
        font-style: normal;
        font-weight: 600;
      }
    }
  }
}

.clear__btn {
  color: rgba(215, 203, 158, 1);
  border: none;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 13px;
  transition: 0.3s;
  padding: 12px 25px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 20px auto 0px;
  border: 1px solid #e8e8e8;
  max-width: 200px;
  border-radius: 4px;
  &:hover {
    background: #fafafa;
    color: black;
  }
}

.coupon__field {
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  margin-top: 24px;
  ::v-deep .control-label {
    padding-bottom: 5px;
  }
}
.discount-label {
  color: #333;
  text-decoration: line-through;
}
</style>
